import ButtonRoot, { ButtonVariant, Props } from './Button'

export default function Button(props: Props) {
  return <ButtonRoot {...props} />
}

export type { ButtonVariant, Props }
